const Tick = ({ size = 12 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-1.5 -1.5 18.00 18.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7071 3.00001L5.50001 12.2071L0.292908 7.00001L1.00001 6.29291L5.50001 10.7929L14 2.29291L14.7071 3.00001Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  );
};

export default Tick;
